import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import 'firebase/auth'

// firebase init goes here
const config = {
    apiKey: "AIzaSyBiQRVqA6-gsLfFffD-EWfueI-20Sy-XBQ",
    authDomain: "socialdiese.firebaseapp.com",
    databaseURL: "https://socialdiese.firebaseio.com",
    projectId: "socialdiese",
    storageBucket: "socialdiese.appspot.com",
    messagingSenderId: "661343182365",
    appId: "1:661343182365:web:56342bb98319f88e1770f4",
    measurementId: "G-WL4XXBJYZC"
}
firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const currentUser = auth.currentUser;
const fbFunctions = firebase.app().functions('europe-west3');

if (location.hostname === "localhost") {
    db.useEmulator("localhost", 8080);
    auth.useEmulator("http://localhost:9099");
    fbFunctions.useEmulator('localhost', 5001);
}

// firebase collections
const usersCollection = db.collection('users')
const adsCollection = db.collection('administration').doc("administration_announcements").collection("administration_announcements_ads");
const admininistrationCollection = db.collection('administration');
const tagsCollection = db.collection('tags');

export {
    db,
    auth,
    storage,
    currentUser,
    usersCollection,
    adsCollection,
    tagsCollection,
    admininistrationCollection,
    fbFunctions,
}


// WEBPACK FOOTER //
// ./src/config/firebase.js